import { UserItem } from '../../../models/types/user/user-managerment'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { resetPasswordSchema } from '../../../models/schema/user'
import { Button } from '@mui/material'
import UserService from '../../../services/api/userManagement'
import { useState } from 'react'
import { notify } from '../../../common/notificationService'
import InputField from '../../../components/form-input/InputField'

type Props = {
    selectedRow: UserItem
    handleCloseResetPassword: () => void
    fetchData: () => Promise<void>
}
const ResetPassword = ({ selectedRow, handleCloseResetPassword, fetchData }: Props) => {
    const [loading, setLoading] = useState(false);
    const schema = resetPasswordSchema
    const {
        register,
        handleSubmit,
        formState: { errors, isDirty }
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            password: "",
            confirmPassword: ""
        },
    });

    const onSubmit = async (data: { password: string, confirmPassword: string }) => {
        setLoading(true)
        try {
            const res = await UserService.resetPassword({
                userId: selectedRow.id,
                password: data.password
            })

            if (res && res.content.status) {
                handleCloseResetPassword()
                notify('Thành công', 'Thay đổi mật khẩu thành công', 'success')
                fetchData()
            }

        } catch (error) {
            notify("Lỗi", "Xảy ra lỗi", "danger");
        } finally {
            setLoading(false)
        }
    }

    return (
        <form className='min-w-[500px] mt-4' onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-4">
                <InputField
                    name="password"
                    label="Mật khẩu mới"
                    type="text"
                    register={register}
                    error={errors.password}
                    required={true}
                />
            </div>
            <div className="mb-4">
                <InputField
                    name="confirmPassword"
                    label="Xác nhận mật khẩu"
                    type="password"
                    register={register}
                    error={errors.confirmPassword}
                    required={true}
                />
            </div>
            <div className="flex justify-center">
                <Button type='submit' disabled={!isDirty} loading={loading} variant="outlined" sx={{ bgcolor: '#2563eb', color: '#fff' }}>Reset</Button>
            </div>
        </form>
    )
}

export default ResetPassword